import React, { Component } from 'react';
// import logo from './logo.svg';
// import './../App.css';

import axios from "axios";
// Amplify Service Integration 
import Amplify from 'aws-amplify';
import awsconfig from './../aws-exports';
import config from '../config'
import { withAuthenticator } from 'aws-amplify-react'; // or 'aws-amplify-react-native';
// import { withAuthenticator } from '@aws-amplify/ui-react'
// import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, Redirect, Switch, Route, Link } from 'react-router-dom';
import Dashboard from './Dashboard';
import WorkBounty from './WorkBounty';
// import Marketplace from './Marketplace';


Amplify.configure(awsconfig);
Amplify.configure({
  Auth: {
    mandatorySignIn: true,
    region: config.cognito.REGION,
    userPoolId: config.cognito.USER_POOL_ID,
    identityPoolId: config.cognito.IDENTITY_POOL_ID,
    userPoolWebClientId: config.cognito.APP_CLIENT_ID
  }
});
Amplify.Storage.configure({
    AWSS3: {
        bucket: 'sppmobilemedical-deployments-mobilehub-391175924',//Your bucket name;
        region: 'us-east-1'//Specify the region your bucket was created in;
    }
});





class App extends Component {
    constructor(props) {
  super(props);
  this.state = {
    username: "null",
    isAuthenticated: false,
    isAuthenticating: true,
    loginUsername: "identityId",
    creationDatesimg: "https://www.spphotonic.com/img/prism.png",
    spectraImg: "https://www.spphotonic.com/img/prism.png",
    conductivityImg: "https://www.spphotonic.com/img/prism.png",
    fluidClarityImg: "https://www.spphotonic.com/img/prism.png",
    bodyHydrationImage: "https://www.spphotonic.com/img/prism.png", //Electrolyte Concentration
    hydrationImg: "https://www.spphotonic.com/img/prism.png"
    }

  this.activateLaser = this.activateLaser.bind(this);
  }

  activateLaser()
  {
  console.log("Lasers Activated")
  }

userHasAuthenticated = authenticated => {
  this.setState({ isAuthenticated: authenticated });


}

handleLogout = async event => {
  await Amplify.Auth.signOut();
  this.userHasAuthenticated(false);
}
async getSummary(user) {

  axios.get('https://sppmobilemedical-deployments-mobilehub-391175924.s3.amazonaws.com/private/us-east-1%3A2981d2a0-e9a1-43f7-99aa-5af80e7f6da1/MLSummaryFile.json')
    .then(response => {
        console.log(response.data);
        var people = []
        for (var i =0;i < response.data['PatientCount']; i++)
        {
          people.push({name: response.data['PatientRecord:'+i],
            index:i
          })
        }
        this.setState({
          devicesConfigured: response.data['DeviceCount'],
          testSubjectsEnrolled: response.data['PatientCount'],
          totalSampleScans: response.data['ScanCount'],
          lambdaMessage: response.data['Title'],
          patientArray: people

        });
        })
}
async getImage() {
  // const fileString = this.state.username + "/" + this.state.username + "-C.png"
  // console.log(fileString)



    // Amplify.Storage.list('', {level:'private', identityId: this.state.loginUsername}) // for listing ALL files without prefix, pass '' instead
    //     .then(result => console.log(result))
    //     .catch(err => console.log(err));
    Amplify.Storage.get('basictest/1-CreationDates.png', {level: 'private', identityId: this.state.loginUsername}) // the identityId of that user })
            .then(result => {
                    // console.log(result)
                    this.setState({ creationDatesimg: result
                                  })
                  })
            .catch(err => console.log(err)); // Gets welcome.png in public space

    Amplify.Storage.get('basictest/details/0-ChemId.png', {level: 'private', identityId: this.state.loginUsername}) // the identityId of that user })
            .then(result => {
                    // console.log(result)
                    this.setState({ spectraImg: result
                                  })
                  })
            .catch(err => console.log(err)); // Gets welcome.png in public space

    Amplify.Storage.get('basictest/1-Conductivity.png', {level: 'private', identityId: this.state.loginUsername}) // the identityId of that user })
            .then(result => {
                    // console.log(result)
                    this.setState({ conductivityImg: result
                                  })
                  })
            .catch(err => console.log(err)); // Gets welcome.png in public space


}

async componentDidMount() {
    Amplify.Auth.currentUserInfo()
      .then(data => {
        this.setState({
          username: data.username,
          loginUsername: data.id
        })
        console.log(data.username)
        console.log(data.id)
        this.getSummary(this)
        this.getImage(this)

        this.setState({ isAuthenticating: false })
      })
      .catch(err => console.log('error: ', err))

}


  buttonOnClick ()
  {

    // alert('Marketplace is not yet Available.');

  }

  render(){
  const childProps = {
    isAuthenticated: this.state.isAuthenticated,
    userHasAuthenticated: this.userHasAuthenticated
  };


  	  return (
    <div className="container">
    <Router>
      <Link to={'/dash'} className="App-link"> 
      <button className="button button-primary button-wide-mobile button-sm" onClick={this.buttonOnClick}> Go To Dash </button>
      </Link> 
      <Link to={'/workbounty'} className="App-link"> 
      <button className="button button-secondary button-wide-mobile button-sm" onClick={this.buttonOnClick}> Go To WorkBounty </button>
      </Link> 
      <br/>


          <Switch>
          <Route exact path="/signup">
          <Redirect to="/dash" />
            </Route>
              <Route path='/dash' component={Dashboard} />
              <Route path='/workbounty' component={WorkBounty} />
          </Switch>
          </Router>
      <button  className="button button-primary button-wide-mobile button-sm" 
      onClick={this.handleLogout}>
        {this.state.isAuthenticated ? true: false}
        "Logout"
      </button>


    </div>
    )
}
}
// export default App;
export default withAuthenticator(App);

